import { Bindable, NotifyProperty, nameof } from "bindable-data";

export class TooltipsInfo extends Bindable {
    public fixIntro: boolean;
    public giftBox: boolean;
    public hourlyBonusRollsIntro: NotifyProperty<boolean>;
    public hourlyBonusWheelIntro: boolean;
    public myBuildingsCounter: boolean;
    public raid: boolean;
    public shopIntro: boolean;
    public steal: boolean;
    public visit: boolean;
    public upgradeIntro: NotifyProperty<boolean>;
    public firstUpgradeByTokens: boolean;
    public ownerWithoutBuildings: boolean;
    public renterQuestIntro?: NotifyProperty<boolean>;
    public tournamentsIntro?: NotifyProperty<boolean>;
    public piggyIntro?: boolean;

    public constructor(
        fixIntro?: boolean,
        giftBox?: boolean,
        hourlyBonusRollsIntro?: boolean,
        hourlyBonusWheelIntro?: boolean,
        myBuildingsCounter?: boolean,
        raid?: boolean,
        shopIntro?: boolean,
        steal?: boolean,
        visit?: boolean,
        upgradeIntro?: boolean,
        firstUpgradeByTokens?: boolean,
        ownerWithoutBuildings?: boolean,
        renterQuestIntro?: boolean,
        tournamentsIntro?: boolean,
        piggyIntro?: boolean
    ) {
        super();
        this.fixIntro = fixIntro ?? false;
        this.giftBox = giftBox ?? false;
        this.hourlyBonusRollsIntro = new NotifyProperty<boolean>(this, nameof(this, "hourlyBonusRollsIntro"), hourlyBonusRollsIntro ?? false);
        this.hourlyBonusWheelIntro = hourlyBonusWheelIntro ?? false;
        this.myBuildingsCounter = myBuildingsCounter ?? false;
        this.raid = raid ?? false;
        this.shopIntro = shopIntro ?? false;
        this.steal = steal ?? false;
        this.visit = visit ?? false;
        this.upgradeIntro = new NotifyProperty<boolean>(this, nameof(this, "upgradeIntro"), upgradeIntro ?? false);
        this.firstUpgradeByTokens = firstUpgradeByTokens ?? false;
        this.ownerWithoutBuildings = ownerWithoutBuildings ?? false;
        this.renterQuestIntro = new NotifyProperty<boolean>(this, nameof(this, "renterQuestIntro"), renterQuestIntro ?? false);
        this.tournamentsIntro = new NotifyProperty<boolean>(this, nameof(this, "tournamentsIntro"), tournamentsIntro ?? false);
        this.piggyIntro = piggyIntro ?? false;
    }

    public updateValues(
        fixIntro?: boolean,
        giftBox?: boolean,
        hourlyBonusRollsIntro?: boolean,
        hourlyBonusWheelIntro?: boolean,
        myBuildingsCounter?: boolean,
        raid?: boolean,
        shopIntro?: boolean,
        steal?: boolean,
        visit?: boolean,
        upgradeIntro?: boolean,
        firstUpgradeByTokens?: boolean,
        ownerWithoutBuildings?: boolean,
        renterQuestIntro?: boolean,
        tournamentsIntro?: boolean,
        piggyIntro?: boolean
    ): void {
        this.fixIntro = fixIntro ?? false;
        this.giftBox = giftBox ?? false;
        this.hourlyBonusRollsIntro.setValue(hourlyBonusRollsIntro ?? false);
        this.hourlyBonusWheelIntro = hourlyBonusWheelIntro ?? false;
        this.myBuildingsCounter = myBuildingsCounter ?? false;
        this.raid = raid ?? false;
        this.shopIntro = shopIntro ?? false;
        this.steal = steal ?? false;
        this.visit = visit ?? false;
        this.upgradeIntro.setValue(upgradeIntro ?? false);
        this.firstUpgradeByTokens = firstUpgradeByTokens ?? false;
        this.ownerWithoutBuildings = ownerWithoutBuildings ?? false;
        this.renterQuestIntro.setValue(renterQuestIntro ?? false);
        this.tournamentsIntro.setValue(tournamentsIntro ?? false);
        this.piggyIntro = piggyIntro ?? false;
    }

    public reset(): void {
        this.fixIntro = false;
        this.giftBox = false;
        this.hourlyBonusRollsIntro.setValue(false);
        this.hourlyBonusWheelIntro = false;
        this.myBuildingsCounter = false;
        this.raid = false;
        this.shopIntro = false;
        this.steal = false;
        this.visit = false;
        this.upgradeIntro.setValue(false);
        this.firstUpgradeByTokens = false;
        this.ownerWithoutBuildings = false;
        this.renterQuestIntro.setValue(false);
        this.tournamentsIntro.setValue(false);
        this.piggyIntro = false;
    }
}
